/**
 * InfoList 정보 목록
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */

// css
import 'assets/css/dev.css'

function Element({
  children,
  level = 1,
  col = 2,
  className = '',
  data = [],
  dataAlign = 'left',
  titleWidth = '60px',
  spanMargin = '',
}) {
  if (level === '2') className += ' level-2'
  if (level === '3') className += ' level-3'
  if (level === '4') className += ' level-4'

  return (
    <ul className={`info-list data-${dataAlign} col-${col} ` + className}>
      {data.map(({ id, title, data, index, color = '', children }, i) => (
        <li key={`${id}_${index || i}`}>
          <span className="label" style={{ width: titleWidth, marginRight: spanMargin === '' ? '16px' : spanMargin }}>
            {title}
          </span>
          {children ? children : <span className={`data ${color}`}>{data}</span>}
        </li>
      ))}
    </ul>
  )
}

export default Element
